import moment from "moment/moment"

export const autoFormatter = str => {
  if(!str) return null

  // ISO date string is 25 chars long:
  if(str.length === 25 && typeof str[0] === 'number') {
    const m = moment(str)
    const isValidDateString = m.isValid()
    if(isValidDateString) {
      return m.format("D. MMM YYYY, HH:mm")
    }
    return str
  }

  if(typeof str !== 'string') return str

  const numOfAtSigns = str.split('').reduce((acc, current) => {
    if(current === '@') return acc + 1
    return acc
  }, 0)

  if(numOfAtSigns === 1) {
    return `<a title="Send mail to ${str}" href="mailto:${str}">${str}</a>`
  }

  if(str.startsWith("+45")) {
    return `<a title="Call ${str}" href="tel:${str}">${str}</a>`
  }

  if(str.startsWith("http")) {
    return `<a title="Go to ${str}" href="${str}">${str}</a>`
  }

  return str
}

export const hasExpiredEvent = endDateTime => {
  if(endDateTime) {
    const endDate = new Date(endDateTime).setHours(new Date(endDateTime).getHours()-1)
    return Boolean(endDate < new Date())
  }
  return false
}

export const hasExpiredAllEvents = items => {
  if(!items || !items.length) return null
  const expiredItems = items.filter(item => hasExpiredEvent(item.endtime))
  return Boolean(expiredItems.length === items.length)
}



// WEBPACK FOOTER //
// ./src/services/service-auto-formatter.js